import React from 'react';

import styled from '@emotion/styled';

import useIntersectionAnimate from '../../hooks/useIntersectionObserver';

interface ICardItems {
  header: string;
  description: string;
  src: string;
}

const CardItems: React.FC<ICardItems> = ({ header, description, src }) => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.4,
  });

  return (
    <Container className='intersection-animate'>
      <ContentArea className='card-text reverse-content'>
        <Header>{header}</Header>
        <Description>{description}</Description>
      </ContentArea>
      <ImageWrapper>
        <Img src={`/static/img/${src}.png`} className='reverse-image' />
      </ImageWrapper>
    </Container>
  );
};

export default CardItems;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 80px;
  padding: 30px 0 30px 10px;
  border-bottom: 1.25px solid ${({ theme }) => theme.palette.borderColor};


    &:nth-of-type(odd)  {
    flex-direction: row-reverse;

    @media (max-width: 884px) {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  }

  &.animate {
    & > div {
      animation-delay: 0.2s;
      animation-duration: 0.5s;
      animation-fill-mode: backwards;
    }
    & > img {
      animation-delay: 0.1s;
      animation-duration: 0.3s;
      animation-fill-mode: backwards;
      animation-name: move;
    }

    &:nth-of-type(even) > div {
      /* background-color: blue; */
      animation-name: left-slide-in;
    }

    &:nth-of-type(odd) > div {
      /* background-color: red; */
      animation-name: right-slide-in;
    }

    @keyframes left-slide-in {
      from {
        transform: translateX(-100%);
      }
      to {
        transform: 0;
      }
    }

    @keyframes right-slide-in {
      from {
        transform: translateX(100%);
      }
      to {
        transform: 0;
      }
    }

    @keyframes move {
      from {
        transform: translateY(10%);
      }
      to {
        transform: 0;
      }
    }
  }

  @media (max-width: 884px) {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

const ContentArea = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 28px;
  align-items: flex-start;

  /* grid-column: 1; */
  grid-column: 2/2;

  @media (max-width: 884px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
`;

const Header = styled.div`
  font-size: 36px;
  font-weight: 700;

  @media (max-width: 884px) {
    font-size: 20px;
    font-weight: 600px;
    line-height: 33.6px;
  }
`;

const Description = styled.div`
  font-size: 20px;

    @media (max-width: 884px) {
    font-size: 18px;
    font-weight: 400px;
  }
`;

const ImageWrapper = styled.div`
width: 60%;
overflow: clip;
display: grid;
place-items: center;
border-radius: 12px;

   @media (max-width: 884px) {
    width: 100%;
`

const Img = styled.img`
  width: 60%
  objectfit: cover;
  position: center;
   
  }
`;


